const TrainingOptions = [
  {
    name: "Seduction",
    description: "Build your ability to seduce others.",
    skill: "seductionProwess",
    onSkillUp: "changeSeductionProwess",
    upgrade: "seductionWardrobe",
  },
  {
    name: "Grappling",
    description: "Spar with another rookie to hone your grappling skills.",
    skill: "grapplingProwess",
    onSkillUp: "changeGrapplingProwess",
    upgrade: "grapplingmatt",
  },
  {
    name: "Tongue Skills",
    description: "Train with the erotic power of your tongue.",
    skill: "tongueProwess",
    onSkillUp: "changeTongueProwess",
    upgrade: "bookOfTongues",
  },
  {
    name: "Touch Skills",
    description: "Practice the softness of your touch.",
    skill: "touchProwess",
    onSkillUp: "changeTouchProwess",
    upgrade: "bookOfSensualTouch",
  },
  {
    name: "Cock/Strapon Skills",
    description: "Practice on one of the onaholes provided.",
    skill: "cockProwess",
    onSkillUp: "changeCockProwess",
    upgrade: "onaholetrainer",
  },
  {
    name: "Pussy Skills",
    description: "Ride the gym's symbian.",
    skill: "vaginaProwess",
    onSkillUp: "changeVaginaProwess",
    reqFemale: true,
    upgrade: "symbian",
  },
  {
    name: "Arse Skills",
    description: "Practice tightening your a-hole.",
    skill: "anusProwess",
    onSkillUp: "changeAnusProwess",
    upgrade: "buttplug",
  },
];

export const ResistanceTraining = [
  {
    name: "Touch Endurance",
    description:
      "Get a rookie to help you build a resistance to a seductive touch.",
    skill: "touchResistance",
    onSkillUp: "changeTouchResistance",
    upgrade: "skinMassager",
  },
  {
    name: "Breast Endurance",
    description: "Get a rookie to fondle your breasts.",
    skill: "breastResistance",
    onSkillUp: "changeBreastResistance",
    reqFemale: true,
    upgrade: "autoGroper",
  },
  {
    name: "Mouth Endurance",
    description: "Get a rookie to play with your mouth and tongue.",
    skill: "mouthResistance",
    onSkillUp: "changeMouthResistance",
    upgrade: "mouthPleaser",
  },
  {
    name: "Cock Endurance",
    description: "Get a rookie and plunder her holes, focus on not orgasming.",
    skill: "cockResistance",
    onSkillUp: "changeCockResistance",
    reqCock: true,
    upgrade: "digitalPussy",
  },
  {
    name: "Pussy Endurance",
    description: "Get someone to stroke your lady orchid.",
    skill: "vaginaResistance",
    onSkillUp: "changeVaginaResistance",
    reqFemale: true,
    upgrade: "megaDildo",
  },
  {
    name: "Arse Endurance",
    description: "Get a rookie to jam some toys up your back tunnel.",
    skill: "anusResistance",
    onSkillUp: "changeAnusResistance",
    upgrade: "arsePleaser",
  },
];

export default TrainingOptions;
